import React, {useEffect, useState} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import LeadFormAndWidgetWrapper from "../lead-form-and-widget-wrapper";
import { NUMBER } from "../../../constants/app-constants";
import getFileExtension from "../../../utils/helpers/get-file-extension";
import { BANNER_MAPPING, HOMEPAGE_TYPES } from "../../../constants/seller-constant";
import Skeleton from "./skeleton";

const HomeBanner = ({
    heading = "",
    headingContent,
    mainHeading,
    subHeading,
    ctaText,
    homePageBanner,
    isSSR,
    fetchHomepageBannersConnect,
    isBrandsVisible = true,
    children,
    homePageType = "",
    isAllianceOffer = false
}) => {

    const { h1, h2, h3, h4 } = headingContent || {};
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (!isSSR && !homePageBanner) {
            setIsFetching(true);
            const cmsPayload = {
                expand: "banner",
                category: BANNER_MAPPING.WEB
            };
            fetchHomepageBannersConnect(cmsPayload).then(() => {
                setIsFetching(false);
            }).catch(() => {
                setIsFetching(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    const getHeading = ({headingText, subHeadingText}) => {
        return `${headingText} ${subHeadingText}`;
    };

    const renderHeading = () => {
        if (mainHeading) return <h1>{mainHeading}</h1>;
        return (<h1 styleName={"styles.offerHeading"}>
            {getHeading({headingText: h1, subHeadingText: h2})}
        </h1>);
    };

    const getBannerHeadingText = () => {
        if (homePageType === HOMEPAGE_TYPES.CITY_PAGE && mainHeading) {
            return  (
                <>
                    <h1 styleName={"styles.cityPageofferHeading"}>{mainHeading}</h1>
                </>
            );
        } else if (heading.length > NUMBER.ZERO) {
            return (
                <h1 styleName={"styles.offerHeading"}>
                    {getHeading({
                        headingText: "Sell used car in",
                        subHeadingText: heading
                    })}
                </h1>
            );
        } else {
            return renderHeading();
        }
    };

    const renderSubHeading = () => {
        if (subHeading) return <p>{subHeading}</p>;
        return <p>{h3}<br/>{h4}</p>;
    };

    if (isFetching) return <Skeleton />;

    return (
        <React.Fragment>
            <Helmet>
                <link
                    rel="preload"
                    as={"image"}
                    href={homePageBanner}
                    type={`image/${getFileExtension(homePageBanner)}`}
                    fetchpriority="high"
                    media="(min-width: 1440px)"
                />
            </Helmet>
            <div styleName={"styles.bannerWrappr"}>
                <img styleName={"styles.banner"} width="1440" height="826" src={homePageBanner} alt="home banner" fetchpriority="high" />
                <div styleName={"styles.bannerTextWrapper"}>
                    <div styleName={"styles.offerText"}>
                        {getBannerHeadingText()}
                        {renderSubHeading()}
                        {children && children}
                    </div>
                    <div styleName={"styles.leadFormWrapper"}>
                        <LeadFormAndWidgetWrapper ctaText={ctaText} isBrandsVisible={isBrandsVisible} isAllianceOffer={isAllianceOffer}/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

HomeBanner.propTypes = {
    heading: PropTypes.string,
    headingContent: PropTypes.func,
    mainHeading: PropTypes.string,
    subHeading: PropTypes.string,
    ctaText: PropTypes.string,
    homePageBanner: PropTypes.string,
    isSSR: PropTypes.bool,
    fetchHomepageBannersConnect: PropTypes.func,
    isBrandsVisible: PropTypes.bool,
    children: PropTypes.any,
    homePageType: PropTypes.string,
    isAllianceOffer: PropTypes.bool
};

export default HomeBanner;
